import { pBase } from './.catalog';

export default class pSifreDegistir extends pBase {
  constructor(options: { MevcutSifre?: string; Sifre?: string }) {
    super();
    this.MevcutSifre = options.MevcutSifre;
    this.Sifre = options.Sifre;
  }

  public MevcutSifre: string | undefined;
  public Sifre: string | undefined;
}
